import { createContext } from 'react'

export const CashFlowContext = createContext({})
